import React, { useEffect, useState } from "react";
import { FateFormula, FateFormulaRequest } from "../../../types/types";
import { FateFormulaService } from "../../../services/fateFormulaService";
import { useToast } from "../../../components/ui";
import FateFormulaLibrary from "../../../components/business/FateFormula/FateFormulaLibrary";

interface CampaignFateFormulasProps {
  campaignId: number;
  canEdit: boolean;
}

const CampaignFateFormulas: React.FC<CampaignFateFormulasProps> = ({ campaignId, canEdit }) => {
  const toast = useToast();
  const [formulas, setFormulas] = useState<FateFormula[]>([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchFormulas = async (s: string) => {
    setLoading(true);
    try {
      const data = await FateFormulaService.listCampaign(campaignId, s || undefined);
      setFormulas(data);
    } catch {
      toast.showToast({ type: "error", message: "Failed to load fate formulas." });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const id = setTimeout(() => fetchFormulas(search), 300);
    return () => clearTimeout(id);
  }, [search, campaignId]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCreate = async (req: FateFormulaRequest) => {
    await FateFormulaService.createCampaign(campaignId, req);
    await fetchFormulas(search);
    toast.showToast({ type: "success", message: "Fate formula created." });
  };

  const handleUpdate = async (id: number, req: FateFormulaRequest) => {
    await FateFormulaService.updateCampaign(campaignId, id, req);
    await fetchFormulas(search);
    toast.showToast({ type: "success", message: "Fate formula updated." });
  };

  const handleDelete = async (id: number) => {
    await FateFormulaService.deleteCampaign(campaignId, id);
    await fetchFormulas(search);
    toast.showToast({ type: "success", message: "Fate formula deleted." });
  };

  return (
    <FateFormulaLibrary
      formulas={formulas}
      readOnly={!canEdit}
      search={search}
      onSearch={setSearch}
      onCreate={handleCreate}
      onUpdate={handleUpdate}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default CampaignFateFormulas;
